export default __webpack_public_path__ + "img/Configuraciones.d5087e2c.png";